const TKeys = {
  PLAY: "PLAY",
  FREE_BET: "FREE_BET",
  GO: "GO",
  CASH_OUT: "CASH_OUT",
  RISK: "RISK",
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  BET_AMOUNT: "BET_AMOUNT",
  BALANCE: "BALANCE",
  NUMBER_OF_ROUNDS: "NUMBER_OF_ROUNDS",
  AUTOBET: "AUTOBET",
  START_AUTOBET: "START_AUTOBET",
  STOP_AUTOBET: "STOP_AUTOBET",
  BET: "BET",
  INFO_SECTION: "INFO_SECTION",
  INFO_SECTION_DESCRIPTION: "INFO_SECTION_DESCRIPTION",
  PROVABLY_FAIRNESS: "PROVABLY_FAIRNESS",
  LAST_ROUND_ID: "LAST_ROUND_ID",
  LAST_ROUND_RESULT: "LAST_ROUND_RESULT",
  ODD: "ODD",
  KEY: "KEY",
  SALT: "SALT",
  HASH: "HASH",
  CHECK_HASH: "CHECK_HASH",
  CHECK: "CHECK",
  NEXT_ROUND: "NEXT_ROUND",
  ABOUT_HASH: "ABOUT_HASH",
  ABOUT_HASH_DESCRIPTION: "ABOUT_HASH_DESCRIPTION",
  TARGET_MULTIPLIER: "TARGET_MULTIPLIER",
  WIN_CHANCE: "WIN_CHANCE",
  NOTIFICATION_MAX_BET: "NOTIFICATION_MAX_BET",
  NOTIFICATION_MIN_BET: "NOTIFICATION_MIN_BET",
  NOTIFICATION_MIN_TARGET_MULTIPLIER: "NOTIFICATION_MIN_TARGET_MULTIPLIER",
  NOTIFICATION_MAX_TARGET_MULTIPLIER: "NOTIFICATION_MAX_TARGET_MULTIPLIER",
  INSUFFICIENT_BALANCE: "INSUFFICIENT_BALANCE",
};

export default TKeys;
